import React,{useState,useEffect} from 'react';
import {motion} from 'framer-motion';
import {supabase} from '../../lib/supabase';
import {useMenu} from '../../context/MenuContext'; // ✅ IMPORT HINZUGEFÜGT
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiClock,FiPlus,FiEdit2,FiTrash2,FiSave,FiX,FiRefreshCw,FiLoader,FiAlertCircle,FiCheck,FiInfo,FiToggleLeft,FiToggleRight}=FiIcons;

const ServiceTimesConfiguration=()=> {
  const {refreshServiceTime}=useMenu(); // ✅ HOOK HINZUGEFÜGT
  const [serviceTimes,setServiceTimes]=useState([]);
  const [isLoading,setIsLoading]=useState(true);
  const [isCreating,setIsCreating]=useState(false);
  const [editingTime,setEditingTime]=useState(null);
  const [isSubmitting,setIsSubmitting]=useState(false);
  const [message,setMessage]=useState('');
  const [messageType,setMessageType]=useState(''); // 'success' or 'error'

  const [formData,setFormData]=useState({
    time: '12:00',
    label: '',
    is_default: false,
    is_active: true,
    description: ''
  });
  const [errors,setErrors]=useState({});

  // Lade Servicezeiten aus der Datenbank
  const loadServiceTimes=async ()=> {
    setIsLoading(true);
    setMessage('');
    try {
      console.log('📋 Loading service times...');
      
      // Test connection first
      const {data: testData,error: testError}=await supabase
        .from('service_times_a7b9c8d6e5')
        .select('count')
        .limit(1);

      if (testError) {
        console.error('❌ Service times connection test failed:',testError);
        throw testError;
      }

      // Load actual data
      const {data,error}=await supabase
        .from('service_times_a7b9c8d6e5')
        .select('*')
        .order('time',{ascending: true});

      if (error) {
        console.error('❌ Service times load error:',error);
        throw error;
      }

      console.log(`✅ ${data?.length || 0} service times loaded`);
      setServiceTimes(data || []);
    } catch (error) {
      console.error('💥 Error loading service times:',error);
      setMessage(`Fehler beim Laden der Servicezeiten: ${error.message}`);
      setMessageType('error');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(()=> {
    loadServiceTimes();
  },[]);

  const validateForm=()=> {
    const newErrors={};

    if (!formData.time) {
      newErrors.time='Zeit ist erforderlich';
    }

    if (!formData.label.trim()) {
      newErrors.label='Bezeichnung ist erforderlich';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length===0;
  };

  const handleSubmit=async (e)=> {
    e.preventDefault();
    if (!validateForm()) return;

    setIsSubmitting(true);
    setMessage('');

    try {
      // Wenn dies als Standard gesetzt wird,alle anderen auf nicht-Standard setzen
      if (formData.is_default) {
        await supabase
          .from('service_times_a7b9c8d6e5')
          .update({is_default: false})
          .neq('id',editingTime?.id || '00000000-0000-0000-0000-000000000000');
      }

      if (editingTime) {
        // Update existing service time
        const {error}=await supabase
          .from('service_times_a7b9c8d6e5')
          .update({
            time: formData.time,
            label: formData.label,
            is_default: formData.is_default,
            is_active: formData.is_active,
            description: formData.description,
            updated_at: new Date().toISOString()
          })
          .eq('id',editingTime.id);

        if (error) throw error;

        setMessage('Servicezeit erfolgreich aktualisiert!');
      } else {
        // Create new service time
        const {error}=await supabase
          .from('service_times_a7b9c8d6e5')
          .insert({
            time: formData.time,
            label: formData.label,
            is_default: formData.is_default,
            is_active: formData.is_active,
            description: formData.description,
            created_at: new Date().toISOString(),
            updated_at: new Date().toISOString()
          });

        if (error) throw error;

        setMessage('Servicezeit erfolgreich erstellt!');
      }

      setMessageType('success');
      handleCancel();
      await loadServiceTimes();
      
      // ✅ AKTUALISIERE DIE SERVICEZEIT IM MENU CONTEXT
      await refreshServiceTime();

      // Nachricht nach 3 Sekunden ausblenden
      setTimeout(()=> {
        setMessage('');
        setMessageType('');
      },3000);

    } catch (error) {
      console.error('Error saving service time:',error);
      setMessage(`Fehler beim Speichern: ${error.message}`);
      setMessageType('error');
      setTimeout(()=> {
        setMessage('');
        setMessageType('');
      },5000);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleEdit=(serviceTime)=> {
    setEditingTime(serviceTime);
    setFormData({
      time: serviceTime.time,
      label: serviceTime.label,
      is_default: serviceTime.is_default,
      is_active: serviceTime.is_active,
      description: serviceTime.description || ''
    });
    setIsCreating(true);
  };

  const handleDelete=async (serviceTimeId)=> {
    if (!confirm('Sind Sie sicher,dass Sie diese Servicezeit löschen möchten?')) return;

    try {
      const {error}=await supabase
        .from('service_times_a7b9c8d6e5')
        .delete()
        .eq('id',serviceTimeId);

      if (error) throw error;

      setMessage('Servicezeit erfolgreich gelöscht!');
      setMessageType('success');
      await loadServiceTimes();
      
      // ✅ AKTUALISIERE DIE SERVICEZEIT IM MENU CONTEXT
      await refreshServiceTime();

      setTimeout(()=> {
        setMessage('');
        setMessageType('');
      },2000);
    } catch (error) {
      console.error('Error deleting service time:',error);
      setMessage(`Fehler beim Löschen: ${error.message}`);
      setMessageType('error');
    }
  };

  const toggleActive=async (serviceTime)=> {
    try {
      const {error}=await supabase
        .from('service_times_a7b9c8d6e5')
        .update({
          is_active: !serviceTime.is_active,
          updated_at: new Date().toISOString()
        })
        .eq('id',serviceTime.id);

      if (error) throw error;

      await loadServiceTimes();
      
      // ✅ AKTUALISIERE DIE SERVICEZEIT IM MENU CONTEXT
      await refreshServiceTime();
    } catch (error) {
      console.error('Error toggling service time:',error);
      setMessage(`Fehler beim Aktualisieren: ${error.message}`);
      setMessageType('error');
    }
  };

  const setAsDefault=async (serviceTime)=> {
    try {
      // Alle anderen auf nicht-Standard setzen
      await supabase
        .from('service_times_a7b9c8d6e5')
        .update({is_default: false});

      // Diese Zeit als Standard setzen
      const {error}=await supabase
        .from('service_times_a7b9c8d6e5')
        .update({
          is_default: true,
          updated_at: new Date().toISOString()
        })
        .eq('id',serviceTime.id);

      if (error) throw error;

      setMessage(`"${serviceTime.label}" wurde als Standard-Servicezeit festgelegt!`);
      setMessageType('success');
      await loadServiceTimes();
      
      // ✅ AKTUALISIERE DIE SERVICEZEIT IM MENU CONTEXT
      await refreshServiceTime();

      setTimeout(()=> {
        setMessage('');
        setMessageType('');
      },2000);
    } catch (error) {
      console.error('Error setting default service time:',error);
      setMessage(`Fehler beim Setzen als Standard: ${error.message}`);
      setMessageType('error');
    }
  };

  const handleCancel=()=> {
    setIsCreating(false);
    setEditingTime(null);
    setFormData({
      time: '12:00',
      label: '',
      is_default: false,
      is_active: true,
      description: ''
    });
    setErrors({});
  };

  const handleInputChange=(e)=> {
    const {name,value,type,checked}=e.target;
    setFormData(prev=> ({
      ...prev,
      [name]: type==='checkbox' ? checked : value
    }));

    // Clear error when user types
    if (errors[name]) {
      setErrors(prev=> ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const activeServiceTimes=serviceTimes.filter(st=> st.is_active);
  const defaultServiceTime=serviceTimes.find(st=> st.is_default);

  return (
    <div>
      <div className="mb-8 flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-gray-800">Servicezeiten-Verwaltung</h1>
          <p className="text-gray-600">Verwalten Sie die verfügbaren Servicezeiten für Menü-Anmeldungen</p>
        </div>
        <div className="flex space-x-3">
          <motion.button
            onClick={loadServiceTimes}
            disabled={isLoading}
            whileHover={{scale: 1.05}}
            whileTap={{scale: 0.95}}
            className={`bg-gray-100 text-gray-700 px-4 py-2 rounded-xl font-semibold hover:bg-gray-200 transition-colors duration-300 flex items-center space-x-2 ${isLoading ? 'opacity-70 cursor-not-allowed' : ''}`}
          >
            <SafeIcon icon={FiRefreshCw} className={isLoading ? 'animate-spin' : ''} />
            <span>Aktualisieren</span>
          </motion.button>
          <motion.button
            onClick={()=> setIsCreating(true)}
            whileHover={{scale: 1.05}}
            whileTap={{scale: 0.95}}
            className="bg-primary-500 text-white px-4 py-2 rounded-xl font-semibold hover:bg-primary-600 transition-colors duration-300 flex items-center space-x-2"
          >
            <SafeIcon icon={FiPlus} />
            <span>Neue Servicezeit</span>
          </motion.button>
        </div>
      </div>

      {/* Status-Nachricht */}
      {message && (
        <motion.div
          initial={{opacity: 0,y: -10}}
          animate={{opacity: 1,y: 0}}
          className={`mb-6 p-4 rounded-xl flex items-center ${
            messageType==='success' 
              ? 'bg-green-50 border border-green-200 text-green-700' 
              : 'bg-red-50 border border-red-200 text-red-700'
          }`}
        >
          <SafeIcon icon={messageType==='success' ? FiCheck : FiAlertCircle} className="mr-2" />
          <span>{message}</span>
        </motion.div>
      )}

      {/* Übersicht */}
      <div className="mb-8 bg-blue-50 border border-blue-200 rounded-xl p-4">
        <div className="flex items-center space-x-2 text-blue-800 mb-2">
          <SafeIcon icon={FiInfo} />
          <span className="font-medium">Aktuelle Konfiguration:</span>
        </div>
        <p className="text-blue-700">
          <strong>{activeServiceTimes.length} von {serviceTimes.length} Servicezeiten</strong> sind aktiviert.
        </p>
        {defaultServiceTime && (
          <p className="text-blue-600 text-sm mt-1">
            Standard-Servicezeit: <strong>{defaultServiceTime.label} ({defaultServiceTime.time?.split(':').slice(0,2).join(':')} Uhr)</strong>
          </p>
        )}
      </div>

      {/* Servicezeiten-Formular */}
      {isCreating && (
        <motion.div
          initial={{opacity: 0,y: -20}}
          animate={{opacity: 1,y: 0}}
          className="bg-white rounded-2xl shadow-md p-6 mb-8"
        >
          <h2 className="text-xl font-bold text-gray-800 mb-6">
            {editingTime ? 'Servicezeit bearbeiten' : 'Neue Servicezeit erstellen'}
          </h2>
          
          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Zeit */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Zeit *
              </label>
              <div className="relative">
                <SafeIcon icon={FiClock} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                <input
                  type="time"
                  name="time"
                  value={formData.time}
                  onChange={handleInputChange}
                  className={`w-full pl-10 pr-4 py-3 border rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors ${
                    errors.time ? 'border-red-500' : 'border-gray-300'
                  }`}
                />
              </div>
              {errors.time && <p className="text-red-500 text-sm mt-1">{errors.time}</p>}
            </div>

            {/* Bezeichnung */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Bezeichnung *
              </label>
              <input
                type="text"
                name="label"
                value={formData.label}
                onChange={handleInputChange}
                className={`w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors ${
                  errors.label ? 'border-red-500' : 'border-gray-300'
                }`}
                placeholder="z.B. Standard-Mittagszeit,Früher Service,Später Service"
              />
              {errors.label && <p className="text-red-500 text-sm mt-1">{errors.label}</p>}
            </div>

            {/* Beschreibung */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Beschreibung (optional)
              </label>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                rows={3}
                className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors"
                placeholder="Zusätzliche Informationen zur Servicezeit..."
              />
            </div>

            {/* Optionen */}
            <div className="space-y-4">
              <div className="flex items-center">
                <input
                  type="checkbox"
                  name="is_active"
                  checked={formData.is_active}
                  onChange={handleInputChange}
                  className="w-4 h-4 text-primary-600 bg-gray-100 border-gray-300 rounded focus:ring-primary-500"
                />
                <label className="ml-2 text-sm font-medium text-gray-700">
                  Aktiv (für Anmeldungen verfügbar)
                </label>
              </div>
              
              <div className="flex items-center">
                <input
                  type="checkbox"
                  name="is_default"
                  checked={formData.is_default}
                  onChange={handleInputChange}
                  className="w-4 h-4 text-primary-600 bg-gray-100 border-gray-300 rounded focus:ring-primary-500"
                />
                <label className="ml-2 text-sm font-medium text-gray-700">
                  Als Standard-Servicezeit setzen
                </label>
              </div>
            </div>

            {/* Buttons */}
            <div className="flex space-x-4">
              <motion.button
                type="submit"
                disabled={isSubmitting}
                whileHover={{scale: 1.02}}
                whileTap={{scale: 0.98}}
                className={`flex-1 flex items-center justify-center space-x-2 bg-primary-500 text-white py-3 rounded-xl font-semibold hover:bg-primary-600 transition-colors duration-300 ${
                  isSubmitting ? 'opacity-70 cursor-not-allowed' : ''
                }`}
              >
                {isSubmitting ? (
                  <>
                    <SafeIcon icon={FiLoader} className="animate-spin" />
                    <span>Wird gespeichert...</span>
                  </>
                ) : (
                  <>
                    <SafeIcon icon={FiSave} />
                    <span>{editingTime ? 'Aktualisieren' : 'Erstellen'}</span>
                  </>
                )}
              </motion.button>
              
              <motion.button
                type="button"
                onClick={handleCancel}
                disabled={isSubmitting}
                whileHover={{scale: 1.02}}
                whileTap={{scale: 0.98}}
                className="flex-1 flex items-center justify-center space-x-2 bg-gray-200 text-gray-700 py-3 rounded-xl font-semibold hover:bg-gray-300 transition-colors duration-300"
              >
                <SafeIcon icon={FiX} />
                <span>Abbrechen</span>
              </motion.button>
            </div>
          </form>
        </motion.div>
      )}

      {/* Servicezeiten-Liste */}
      <div className="bg-white rounded-2xl shadow-md overflow-hidden">
        <div className="bg-gray-50 px-6 py-4 border-b border-gray-200">
          <h3 className="text-lg font-bold text-gray-800">
            Servicezeiten ({serviceTimes.length})
          </h3>
        </div>

        {isLoading ? (
          <div className="p-8 text-center">
            <SafeIcon icon={FiLoader} className="mx-auto text-4xl text-primary-500 animate-spin mb-4" />
            <p className="text-gray-600">Servicezeiten werden geladen...</p>
          </div>
        ) : serviceTimes.length > 0 ? (
          <div className="divide-y divide-gray-200">
            {serviceTimes.map((serviceTime)=> (
              <motion.div
                key={serviceTime.id}
                initial={{opacity: 0}}
                animate={{opacity: 1}}
                className="p-6 hover:bg-gray-50 transition-colors"
              >
                <div className="flex items-center justify-between">
                  <div className="flex-1">
                    <div className="flex items-center space-x-3">
                      <div className={`w-4 h-4 rounded-full ${serviceTime.is_active ? 'bg-green-500' : 'bg-gray-300'}`}></div>
                      <div className={`p-2 rounded-lg ${serviceTime.is_default ? 'bg-primary-100 text-primary-600' : 'bg-gray-100 text-gray-600'}`}>
                        <SafeIcon icon={FiClock} />
                      </div>
                      <div>
                        <div className="flex items-center space-x-2">
                          <h4 className={`font-semibold ${serviceTime.is_active ? 'text-gray-900' : 'text-gray-500'}`}>
                            {serviceTime.label}
                          </h4>
                          {serviceTime.is_default && (
                            <span className="text-xs bg-primary-500 text-white px-2 py-1 rounded-full">
                              Standard
                            </span>
                          )}
                        </div>
                        <p className="text-lg font-mono text-gray-700">
                          {/* ✅ FORMATIERE ZEIT OHNE SEKUNDEN */}
                          {serviceTime.time?.split(':').slice(0,2).join(':') || '12:00'} Uhr
                        </p>
                        {serviceTime.description && (
                          <p className="text-xs text-gray-500 mt-1">{serviceTime.description}</p>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="flex items-center space-x-2">
                    <span className={`text-xs px-2 py-1 rounded-full ${
                      serviceTime.is_active 
                        ? 'bg-green-100 text-green-600' 
                        : 'bg-gray-100 text-gray-600'
                    }`}>
                      {serviceTime.is_active ? 'Aktiv' : 'Inaktiv'}
                    </span>

                    {!serviceTime.is_default && serviceTime.is_active && (
                      <motion.button
                        onClick={()=> setAsDefault(serviceTime)}
                        whileHover={{scale: 1.05}}
                        whileTap={{scale: 0.95}}
                        className="p-2 bg-primary-100 text-primary-600 rounded-lg hover:bg-primary-200 transition-colors text-xs font-medium"
                        title="Als Standard setzen"
                      >
                        Standard
                      </motion.button>
                    )}

                    <motion.button
                      onClick={()=> toggleActive(serviceTime)}
                      whileHover={{scale: 1.05}}
                      whileTap={{scale: 0.95}}
                      className={`p-2 rounded-lg transition-colors ${
                        serviceTime.is_active 
                          ? 'bg-red-100 text-red-600 hover:bg-red-200' 
                          : 'bg-green-100 text-green-600 hover:bg-green-200'
                      }`}
                      title={serviceTime.is_active ? 'Deaktivieren' : 'Aktivieren'}
                    >
                      <SafeIcon icon={serviceTime.is_active ? FiToggleRight : FiToggleLeft} className="text-xl" />
                    </motion.button>

                    <motion.button
                      onClick={()=> handleEdit(serviceTime)}
                      whileHover={{scale: 1.05}}
                      whileTap={{scale: 0.95}}
                      className="p-2 bg-blue-100 text-blue-600 rounded-lg hover:bg-blue-200 transition-colors"
                      title="Bearbeiten"
                    >
                      <SafeIcon icon={FiEdit2} />
                    </motion.button>

                    <motion.button
                      onClick={()=> handleDelete(serviceTime.id)}
                      whileHover={{scale: 1.05}}
                      whileTap={{scale: 0.95}}
                      className="p-2 bg-red-100 text-red-600 rounded-lg hover:bg-red-200 transition-colors"
                      title="Löschen"
                    >
                      <SafeIcon icon={FiTrash2} />
                    </motion.button>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        ) : (
          <div className="p-8 text-center">
            <SafeIcon icon={FiClock} className="mx-auto text-4xl text-gray-400 mb-4" />
            <p className="text-gray-500 mb-4">Noch keine Servicezeiten konfiguriert</p>
            <motion.button
              onClick={()=> setIsCreating(true)}
              whileHover={{scale: 1.05}}
              whileTap={{scale: 0.95}}
              className="inline-flex items-center space-x-2 text-primary-600 hover:text-primary-700"
            >
              <SafeIcon icon={FiPlus} />
              <span>Erste Servicezeit erstellen</span>
            </motion.button>
          </div>
        )}
      </div>

      {/* Info-Box */}
      <div className="mt-8 bg-amber-50 border border-amber-200 rounded-xl p-6">
        <div className="flex items-center space-x-2 text-amber-800 mb-3">
          <SafeIcon icon={FiInfo} />
          <span className="font-medium">Wichtige Hinweise:</span>
        </div>
        <ul className="text-amber-700 text-sm space-y-1">
          <li>• <strong>Standard-Servicezeit:</strong> Wird automatisch bei Anmeldungen vorausgewählt</li>
          <li>• <strong>Aktive Zeiten:</strong> Nur aktive Servicezeiten stehen für Anmeldungen zur Verfügung</li>
          <li>• Bestehende Anmeldungen werden von Änderungen nicht beeinflusst</li>
          <li>• Es sollte immer mindestens eine aktive Servicezeit vorhanden sein</li>
          <li>• Die Zeiten werden automatisch in chronologischer Reihenfolge sortiert</li>
          <li>• <strong>Änderungen werden sofort auf der Website sichtbar</strong></li>
        </ul>
      </div>
    </div>
  );
};

export default ServiceTimesConfiguration;